import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { useEditNote } from "../../hooks/useCrm";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
const initvalue = {
  DescriptionNote: "",
  IdNote: null,
};
export const EditNoteModal = ({ show, handleClose, note }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  useEffect(() => {
    if (note) {
      setForm({
        ...form,
        IdNote: note?.IdNote,
        DescriptionNote: note?.DescriptionNote,
      });
    }
  }, [note]);
  const { mutateAsync: EditNote } = useEditNote();
  const handleEditNote = async (data) => {
    await EditNote(data).then(() => setForm(initvalue));
  };
  return (
    <BootstrapModal
      modaltitle="ویرایش یادداشت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <SimpleTextArea
            value={form.DescriptionNote}
            onChange={(e) =>
              setForm({ ...form, DescriptionNote: e.target.value })
            }
          />
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleEditNote(form);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
